import * as React from "react";
import {Header, Logo } from "@vwfs-bronson/bronson-react";
import LogoDesktop from "./images/vwfs-default-logo_desktop.svg";
import LogoMobile from "./images/vwfs-default-logo_mobile.svg";
import { useTranslation } from "react-i18next";

export interface PageHeaderProps {
  documentTitle?: string;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
}

const PageHeader = (props: PageHeaderProps) => {
  const { t } = useTranslation();
  const { documentTitle, title } = props;
  const docTitle = documentTitle ? documentTitle : title;

  React.useEffect(() => {
    document.title = `${docTitle || ""}`;
  }, [docTitle]);

  return (
    <>
      <Header
        testId="appHeader"
        staticHeader
        logo={
          <div style={{ display: "flex", maxHeight: "70px" }}>
            <Logo alt={t("login:logoAlt")} ariaLabel={t("login:logoAlt")} testId="appHeaderLogo" aria-label="Zur Startseite" src={LogoDesktop} srcSmall={LogoMobile} href="https://www.vwfs.de/" />
          </div>
        }
      >
      </Header>
    </>
  );
};

export default PageHeader
